// extracted by mini-css-extract-plugin
module.exports = {"item":"i-","dark":"i_","light":"ja","toggle":"jb"};